import React, { useEffect } from "react";
import { useLocation, useHistory } from 'react-router-dom';
import apiCaller from "../../utils/api-caller";
import { Button, Col, Icon, Layout, Row } from "antd";
import templateStore from "../../stores/templateStore";
import webSettingStore from "../../stores/webSettingStore";
import loginStore from "../../stores/GuestLogin/loginStore";
import CmsLanguageStore from "../../stores/CMS/CmsLanguageStore";
import { observer } from "mobx-react";

const { Content } = Layout

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const OrderPayResult = observer(() => {
    const history = useHistory()

    const query = useQuery();

    const returnRef = query.get('returnRef'); // 获取 query 参数

    const checkPaymentStatusFn = async () => {
        const result = await apiCaller.getPaymentStatusApi(returnRef)
    }

    const { activeTemplate } = templateStore

    const back = () => {
        history.push('/');
    }

    const handlerInitFn = () => {
        const roomNo = loginStore.getRoomNo();
        if (!roomNo) {
            history.push('/login');
        }

        loginStore.authenticateGuest().then(response => {
            if (!response) {
                history.push('/login');
            }
        });

        CmsLanguageStore.getActives().then(() => {
            templateStore.getActive().then(() => {
                webSettingStore.getData();
            });
        });
    }

    useEffect(() => {
        checkPaymentStatusFn()
        handlerInitFn()
    }, [])

    const { data: webSettting } = webSettingStore

    return <React.Fragment>
        <Layout className='stm-layout'>
            {
                webSettting && activeTemplate
                    ?
                    <>
                        <Content>
                            {/* Header */}
                            <Row>
                                <Col
                                    span={24}
                                    className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                    style={{
                                        fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                        background: activeTemplate.templateSetting.header.backgroundColor,
                                        color: activeTemplate.templateSetting.header.color,
                                        fontSize: activeTemplate.templateSetting.header.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                    }}
                                >
                                    <Row>
                                        <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={back}>
                                            <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                        </Col>
                                        <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                            {webSettting.orderPopupTitleText}
                                        </Col>
                                        <Col span={4} />
                                    </Row>
                                </Col>
                            </Row>

                            {/* Body */}
                            <Row className='stm-margin-top-50 stm-padding-bottom-100 stm-background-white'>
                                <Col span={1} />
                                <Col span={22}>
                                    <Row>
                                        <Col span={24}
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                color: activeTemplate.templateSetting.text.color,
                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                textAlign: 'center',
                                                marginTop: 32
                                            }}>
                                            {webSettting.orderPopupSuccessText}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={1} />
                            </Row>

                            {/* Confirm */}
                            <Row>
                                <Col
                                    span={24}
                                    className='stm-position-fixed stm-bottom-0 stm-padding-bottom-15 stm-background-white stm-padding-top-15 stm-max-width-500'
                                >
                                    <Row>
                                        <Col span={1} />
                                        <Col span={22} >
                                            <Button
                                                className='stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2'
                                                style={{
                                                    background: activeTemplate.templateSetting.footer.backgroundColor,
                                                    fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                                    fontSize: activeTemplate.templateSetting.footer.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.footer.fontSize + 2}px`,
                                                    color: activeTemplate.templateSetting.footer.color
                                                }}
                                                onClick={() => history.push('/order')}
                                            >
                                                {webSettting.goToOrderText}
                                            </Button>
                                        </Col>
                                        <Col span={1} />
                                    </Row>
                                </Col>
                            </Row>
                        </Content>
                    </>
                    :
                    null
            }
        </Layout>
    </React.Fragment>
})

export default OrderPayResult